import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Igreja = () => {
  const wpp = generateWhatsAppLink('igreja', 'igreja-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Igrejas | Sustenta LED</title>
        <meta name="description" content="LED para igrejas: conforto visual e eficiência. Somos atacadistas e distribuidores com soluções para templos e auditórios." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Igrejas</h1>
              <p>Atendemos igrejas e templos com soluções LED que oferecem conforto visual, eficiência e durabilidade. Somos atacadistas e distribuidores com portfólio adequado para salões e auditórios.</p>
              <p>Orientamos posicionamento, níveis de iluminação e temperatura de cor para atividades litúrgicas e eventos.</p>
              <p>Solicite cotação e receba atendimento especializado para sua igreja.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_quemsomos_sustentaled.jpg" alt="LED para Igrejas - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Igreja;
